module.exports = __webpack_public_path__ + "media/images/business/icon-arrow-right-85744f76d17839120736a45e4b5a947a.svg";